import { render } from "./Input.vue?vue&type=template&id=64ee6a44"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"
script.render = render

export default script